// 引入路由和storage工具函数
// import storage from '@/util/storage'
// import router from "@/router/index"

let lastTime = new Date().getTime()
let currentTime = new Date().getTime()
let timeOut = 10 * 60 * 1000 //设置超时时间: 30分钟

window.onload = function () {
  window.document.onmousedown = function () {
    localStorage.setItem("lastTime", new Date().getTime())
  }
};

export default function () {
    /* 定时器 间隔30秒检测是否长时间未操作页面 */
    window.setInterval(function(){

        currentTime = new Date().getTime();		//更新当前时间
        lastTime = localStorage.getItem("lastTime");

        if (currentTime - lastTime > timeOut) { //判断是否超时

            // 清除storage的数据(登陆信息和token)
            localStorage.clear();
            sessionStorage.clear();
        
            // 跳到登陆页
            
            window.location.href = "/#/login"
         }

    }, 30000);
}


// WEBPACK FOOTER //
// ./src/util/astrict.js